module.exports = __webpack_public_path__ + "static/media/09_3.478da4c0.png";